import { connect } from 'react-redux';
import { findIndex } from 'lodash';

interface Props {
  children: any;
  auth: any;
  require: string;
  exclude: boolean;
  alt: any;
}

const Permission = ({
  children,
  auth,
  require,
  exclude = false,
  alt = null,
}: Props) => {
  if (!auth.isAuthenticated) {
    return alt;
  }

  // Override if the user is a global admin
  if (auth.isGlobalAdmin) {
    return exclude ? alt : children;
  }

  // Check if the user has the permission
  let index = findIndex(auth.user.permissions, {
    permission: require,
  });
  if (index === -1) {
    index = findIndex(auth.user.permissions, {
      permission: 'ADMIN',
    });
  }

  // Don't display contents if requirements are not met
  if ((!exclude && index === -1) || (exclude && index !== -1)) {
    return alt;
  }

  return children;
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(Permission);
